export default __webpack_public_path__ + "static/media/Raiders.213d6445.png";